import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {BerthVisit, BerthVisitInfo, OrderStatus} from '@portbase/bezoekschip-service-typescriptmodels';
import {VisitContext} from '../../visit-context';
import {PortvisitUtils} from "../../../refdata/portvisit-utils";

@Component({
    selector: 'app-movement-between-berths',
    templateUrl: './movement-between-berths.component.html',
    styleUrls: ['./movement-between-berths.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MovementBetweenBerthsComponent implements OnInit {

  areNauticalServicesApplicable = PortvisitUtils.areNauticalServicesApplicable;
  context = VisitContext;

  @Input()berthVisit: BerthVisit;
  @Input() isNextBerthVisits: boolean;
  @Input() idx: number;
	@Input() firstBerth: boolean;
	@Input() lastBerth: boolean;

  constructor() { }

  ngOnInit() {
  }

	getBerthVisitInfo(): BerthVisitInfo {
		return VisitContext.savedVisit.berthVisitInfos[this.berthVisit.id];
	}

	getOrderStatus(): OrderStatus {
    return this.getBerthVisitInfo()?.harbourMasterInfo?.orderStatus;
	}

  get getNextBerthVisit(): BerthVisit {
		let berthVisits = [];
		if (this.isNextBerthVisits) {
			berthVisits = this.context.visit.nextVisitDeclaration.nextBerthVisits;
		} else {
			if (this.context.isOrganisationNextDeclarant() && this.isBerthOfTransfer && this.context.visit.nextVisitDeclaration?.nextBerthVisits.length > 0) {
				return this.context.visit.nextVisitDeclaration.nextBerthVisits[0];
			}
			berthVisits = this.context.visit.visitDeclaration.portVisit.berthVisits;
		}
		return berthVisits.indexOf(this.berthVisit) + 1 < berthVisits.length ? berthVisits[this.idx + 1] : null;
	}

  get arrivalBerthVisitId(): string {
    return this.getNextBerthVisit?.id;
  }
  get departureBerthVisitId(): string {
    return this.berthVisit?.id;
  }

  get isBerthOfTransfer(): boolean {
		return this.lastBerth && !this.isNextBerthVisits && !!this.context.visit.nextDeclarant;
	}

	nextBerthVisitHasAta(): boolean {
		let nextBerthVisit = this.context.visit.visitDeclaration.portVisit.berthVisits[this.context.visit.visitDeclaration.portVisit.berthVisits.indexOf(this.berthVisit) + 1];
		return nextBerthVisit && nextBerthVisit.ata != null;
	}
}
